export default (state = {}, action) => {
  switch (action.type) {
    case  'SET_USER':
      return {...state, ...action.user}
    case 'UNSET_USER':
      return null
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js